import { ESideBarChipType } from '../types';
import { FC } from 'react';
import { sidebarChipConfig } from '../constants';
import { cn } from 'components/lib/utils';
import Chip from 'components/Chip/Chip';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger
} from 'components/ui';

type SidebarItemChipProps = {
  type: ESideBarChipType | undefined;
  isDisabled?: boolean;
};
const SidebarMenuItemChip: FC<SidebarItemChipProps> = ({
  type,
  isDisabled
}) => {
  if (!type) return null;
  const { title, styles, disabledStateStyles, tooltip } =
    sidebarChipConfig[type];
  const chipStyles = cn(
    'w-full ml-auto',
    isDisabled && disabledStateStyles ? disabledStateStyles : styles
  );

  const chipElement = (
    <Chip variant="bordered" className={chipStyles}>
      {title}
    </Chip>
  );

  if (tooltip && !isDisabled) {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <div>{chipElement}</div>
          </TooltipTrigger>
          <TooltipContent
            side="right"
            align="start"
            className="relative rounded-md border border-base-popover bg-base-popover shadow-md py-1.5 px-3 w-[405px] whitespace-normal break-words text-p-s text-base-popoverForeground z-[1000]"
          >
            {tooltip}
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  return chipElement;
};

export default SidebarMenuItemChip;
